export default "__VITE_ASSET__385ac7db__"